import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class HostGalleryCollection extends ThemeComponent {

    protected itemsPerPage: number = 16;
    protected totalPages: number = 1;
    protected currentPage: number = 1;

    init() {
        this.setupPagination();
        this.setupFilter();
    }

    private setupFilter() {
        const filters = this.querySelectorAll<HTMLElement>('.category-filter__items');

        for (const filter of filters) {
            filter.addEventListener('click', (event: Event) => {
                const target = event.currentTarget as HTMLElement;
                const selectedCategory = target.getAttribute('data-id');
                this.filterItems(selectedCategory);
                // Remove 'active' class from all filters
                for (const item of filters) {
                    item.classList.remove('active');
                }

                // Add 'active' class to the clicked filter
                target.classList.add('active');

            });
        }
    }

    private filterItems(selectedCategory: string | null) {
        const items = document.querySelectorAll<HTMLElement>('.host-gallery-item'); // Fix selector

        for (const item of items) {
            const itemCategoryStr = item.getAttribute('data-category');

            // If "All" is selected, show all items
            if (selectedCategory === "all") {
                item.classList.add('show');
                continue;
            }

            if (!itemCategoryStr) {
                item.classList.remove('show');
                continue;
            }

            try {
                // Parse JSON array from data-category attribute
                const itemCategories: string[] = JSON.parse(itemCategoryStr);
                item.classList.add('show');

                // Check if selectedCategory is in the array
                if (selectedCategory === null || itemCategories.includes(selectedCategory)) {
                    item.classList.add('show');
                } else {
                    item.classList.remove('show');
                }
            } catch (error) {
                item.classList.remove('show'); // Hide item if parsing fails
            }
        }

        this.resetPagination();
    }

    private setupPagination() {
        this.totalPages = Math.ceil(document.querySelectorAll('.host-gallery-item').length / this.itemsPerPage);
        this.updatePaginationDisplay();

        // Add event listeners for pagination buttons
        document.querySelector('.pagination-prev')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage - 1);
        });

        document.querySelector('.pagination-next')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage + 1);
        });

        document.querySelector('.pagination-first')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(1);
        });

        document.querySelector('.pagination-end')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.totalPages);
        });
    }

    private resetPagination() {
    // Reset pagination when filter changes
        this.currentPage = 1;
        this.itemsPerPage = 16;
        // eslint-disable-next-line max-len
        this.totalPages = Math.ceil(document.querySelectorAll('.host-gallery-item.show').length / this.itemsPerPage);
        this.updatePaginationDisplay();

        const pagination = document.querySelector('.pagination') as HTMLElement;

        if(pagination) {
            if(this.totalPages < 2) {
                pagination.style.display = 'none';
            }else{
                pagination.style.display = 'flex';
            }
        }

        // Add event listeners for pagination buttons
        document.querySelector('.pagination-prev')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage - 1);
        });

        document.querySelector('.pagination-next')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.currentPage + 1);
        });

        document.querySelector('.pagination-first')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(1);
        });

        document.querySelector('.pagination-end')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToPage(this.totalPages);
        });
    }

    private goToPage(page: number) {
        if (page < 1 || page > this.totalPages) {return;}
        this.currentPage = page;
        this.updatePaginationDisplay();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    private updatePaginationDisplay() {
        const items = document.querySelectorAll('.host-gallery-item.show') as NodeListOf<HTMLElement>;
        for (const [index, item] of Array.from(items).entries()) {
            const itemPage = Math.floor(index / this.itemsPerPage) + 1;
            if (itemPage === this.currentPage) {
                item.classList.add('showItem');
            } else {
                item.classList.remove('showItem');
            }
        }

        // Update pagination info and button states
        const paginationInfo = document.querySelector('.pagination-info');
        if (paginationInfo) {
            paginationInfo.textContent = `${this.currentPage} of ${this.totalPages}`;
        }

        // Toggle button disabled states
        const paginationPrev = document.querySelector('.pagination-prev');
        const paginationNext = document.querySelector('.pagination-next');
        const paginationFirst = document.querySelector('.pagination-first');
        const paginationEnd = document.querySelector('.pagination-end');

        paginationPrev?.classList.toggle('pagination__button--disabled', this.currentPage <= 1);
        paginationNext?.classList.toggle('pagination__button--disabled', this.currentPage >= this.totalPages);
        paginationFirst?.classList.toggle('pagination__button--disabled', this.currentPage <= 1);
        paginationEnd?.classList.toggle('pagination__button--disabled', this.currentPage >= this.totalPages);
    }

}
